/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import brandConfig from "../config/brands.config.json";
import settingsConfig from "../config/settings.config.json";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { GET_BAND } from "../graphql/getBand.query";
const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IBrandDetailsMethods extends IPluginMethodMap {
  getBrandDetails(args: any): Promise<any>;
}

export class BrandDetailsService implements IAgentPlugin {
  readonly methods: IBrandDetailsMethods;

  constructor() {
    this.methods = {
      getBrandDetails: this.getBrandDetails.bind(this),
    };
  }

  async getBrandDetails(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      const storageSrv = StorageModule.getInstance();
      const localStorage = storageSrv?.get("currencyExchangeLocal", "local");
      let band;
      if (is.existy(localStorage?.band)) {
        band = localStorage?.band;
      }
      if (client && band) {
        const res = await client.query({
          query: GET_BAND,
          variables: {
            filter: {
              bandName: band,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getBand) {
          console.log(res?.data?.getBand);
          storageSrv.set("theme", res?.data?.getBand, "local");
          return {
            dataConfig: this.formatTweetyProps(res?.data?.getBand),
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
  }
  private formatTweetyProps = (res?: any) => {
    console.log(res);
    let _res: any = settingsConfig.TWEETY_PROPS;
    let initialData: any;
    initialData = {
      brandLogo: res?.bandLogo,
      primaryColor: res?.primaryTheme,
      secondaryColor: res?.secondaryTheme,
    };
    _res.initialData = initialData;
    console.log(_res);
    return _res;
  };
}
